<template>
  <Loading
    v-model:active="isLoading"
    color="#3C9F00"
    loader="spinner"
    background-color="#FFFFFF"
    :is-full-page="true"
  />
</template>

<script>
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const isLoading = ref(true);

export default {
    name: 'LoginTokenVerify',
    components: {
        Loading
    },
    created() {
        this.checkQueryParams();
    },
    methods: {
        async checkQueryParams() {
            isLoading.value = true;
            const authStore = useAuthStore();
            const queryParams = this.$route.query;

            if (queryParams.access_token) {
                const result = await authStore.checkAccessTokenAndRedirect(queryParams.access_token);
                if (!result) {
                    this.$router.push({ name: 'SignIn' });
                }
            }
        },
    }
}
</script>

